import { useMutation } from '@tanstack/react-query';

import { type components, updatePartyById } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

type PartyPatch = components['schemas']['PartyPatchCmd'];

type UpdatePartyVariables = {
  partyId: string;
  values: Omit<PartyPatch, 'claims'>;
};

export default function useUpdateParty() {
  return useMutation({
    mutationFn: ({ partyId, values }: UpdatePartyVariables) =>
      updatePartyById(
        {
          params: { path: { party_id: partyId } },
          body: values as PartyPatch,
        },
        wgApi,
      ),
  });
}
